<template>
  <div class="room-services">
    <div class="room-type__item">
      <!-- <transition name="fade"> -->
        <div class="register-box__info col-xl-12 room-update" v-show="show">
          <div class="room-update__e">
            <p class="room-services__title">Genres</p>
            <h1 class="room-update__title">SELECT GENRES</h1>
<!--             <div class="choose-wrp">
              <div class="dorm-inf__item"
                   :class="n % 2 ? 'active' : 'disable'"
                   v-for="n in bina" :key="n">
                <span class="dorm-inf__icon">
                  <svg-icon type="icon-fridge"/>
               </span>
                <span class="dorm-inf__title">{{n.label}}</span>
              </div>
              <input class="add-services" placeholder="Başka ekle"></input>
            </div>
          </div>
        </div>

      </transition>
    </div> 
    
    <div class="dorm-inf__item "> -->       

   <div class="ana_div">
    
    <div class="div" id="div"><strong></strong>
                        <div
                      v-for="property in bina"
                      :key="property.id"
                    >
                      <label class="properties-cont" @click="checkClick">
                        {{ property.title }}
                        <input
                          type="checkbox"
                          v-model="property.selected"
                          :key="property.id"
                          :value="property.id"
                        >
                        <span class="checkmark"></span>
                      </label>
                    </div>

    </div>
    <div class="div" id="div2"><strong></strong>
                          <div
                      v-for="property in oda"
                      :key="property.id"
                    >
                      <label class="properties-cont" @click="checkClick">
                        {{ property.title }}
                        <input
                          type="checkbox"
                          v-model="property.selected"
                          :key="property.id"
                          :value="property.id"
                        >
                        <span class="checkmark"></span>
                      </label>
                    </div>      
    </div>
    
    <div class="div" id="div3"><strong></strong>
                         <div
                      v-for="property in hizmetler"
                      :key="property.id"
                    >
                      <label class="properties-cont" @click="checkClick">
                        {{ property.title }}
                        <input
                          type="checkbox"
                          v-model="property.selected"
                          :key="property.id"
                          :value="property.id"
                        >
                        <span class="checkmark"></span>
                      </label>
                    </div>       
                     </div>
                    </div>
                    </div>
                   </div>   
          </div>            
  </div>
</template>

<script>
import MyDormGaleriThumb from '@/components/MyDormGalleryThumb'
import SelectBox from '@/components/SelectBox'

export default {
  name: 'MyDormServices',
  components: {
    MyDormGaleriThumb, SelectBox
  },
    props: {
    bina: Array,
    oda: Array,
    hizmetler: Array
  },
  data () {   
    return {
        props: [],
      show: true,
    }
  },
  methods: {
    checkClick () {

    } ,
    updateRoom () {
      if (this.show === true) { this.show = false } else {
        this.show = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 // @import url(https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css);
  .room-services {
    .add-services{
      width: 100%;
      background-color: #eff3fb;
      padding: 13px 28px;
      border-radius: 6px;
      text-align: left;
      border: 1px solid #e8ecf3;
      color: #9299b3;
      opacity: 0.6;
      padding-bottom: 9px;
      font-size: 15px;
      font-weight: bold;
    }
    .room-update {
      border: none;
      background: white;
    }
    &__title{
      font-weight: bold;
    }

    .room-update{
      &__title{
        position: relative;
        font-size: 11px;
        font-weight: bold;
        color: #b6bcc9;
        margin-top: 7px;
      }
    }

    .room-type{
      &__item{
        &:after{
          display: none;
        }
      }
    }
  }

  .dorm-inf__title{
    font-size: 16px;
    font-weight: bold;
  }

.properties-cont {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.properties-cont input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.properties-cont:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.properties-cont input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #666;
  margin-bottom: 15px;
}

/* Show the checkmark when checked */
.properties-cont input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.properties-cont .checkmark:after {
  left: 10px;
  top: 7px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.myitem {
    display: inline;
}

.myheight {
 height: 1400px;
}

.ana_div {
    
    height: 300px;
    width: 960px;
    margin-right: auto;
    margin-left: auto;
    
}

.div {
    
    float: left;
    display: inline-block;
    height: 200px;
    width: 300px;
    margin: 10px;

}
</style>
